import PropTypes from 'prop-types'
import { LuMoveLeft, LuMoveRight } from 'react-icons/lu'
import Select from 'react-select'

export default function TableFooter({
  previousPage,
  canPreviousPage,
  pageIndex,
  pageOptions,
  nextPage,
  canNextPage,
  gotoPage,
  rows,
  pageSize,
  setPageSize
}) {
  const pageSizeOptions = [
    { label: '25 registros', value: 25 },
    { label: '50 registros', value: 50 },
    { label: '75 registros', value: 75 },
    { label: '100 registros', value: 100 },
    { label: '150 registros', value: 150 },
    { label: '250 registros', value: 250 },
    { label: '500 registros', value: 500 }
  ]

  return (
    <div className="grid w-full grid-cols-12">
      <div
        title={'Página ' + (pageIndex + 1)}
        className="flex col-span-12 space-x-1 text-sm text-gray-500 lg:col-span-4 dark:text-gray-400"
      >
        <span>Página</span>
        <span className="font-medium text-gray-700 dark:text-gray-100">
          {pageIndex + 1} de {pageOptions.length}
        </span>
      </div>

      <div className="flex items-center justify-start col-span-12 mt-3 lg:col-span-4 lg:justify-center gap-x-4 lg:mt-0">
        <Select
          className="w-1/2 text-sm leading-tight sm:w-36"
          onChange={(e) => {
            setPageSize(e.value)
          }}
          placeholder="Seleccionar..."
          options={pageSizeOptions}
          getOptionLabel={(o) => o.label}
          getOptionValue={(o) => o.value}
          isSearchable={false}
          menuPlacement="top"
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderRadius: '0.125rem',
              cursor: 'pointer',
              boxShadow: state.isFocused
                ? '0 0 0 calc(3px + 0px) rgba(37, 194, 209, 0.2)'
                : 'none',
              minHeight: 'auto',
              lineHeight: '20px',
              border: '1px solid #FCB05A',
              '&:hover': {
                border: '1px solid #FCB05A'
              },
              outline: '2px solid transparent',
              outlineOffset: '2px'
            }),
            valueContainer: (baseStyles) => ({
              ...baseStyles,
              height: '100%',
              padding: '0.50rem',
              position: 'relative',
              cursor: 'pointer'
            }),
            input: (baseStyles) => ({
              ...baseStyles,
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              margin: '0',
              paddingTop: '0',
              paddingBottom: '0',
              cursor: 'pointer'
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
              marginLeft: '0',
              marginRight: '0'
            }),
            indicatorsContainer: (baseStyles) => ({
              ...baseStyles,
              cursor: 'pointer'
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              padding: '0px 8px'
            })
          }}
          value={pageSizeOptions.find((option) => {
            return option.value === pageSize
          })}
        />

        {/* Búscador de página, comentado porque no lo usamos mucho y porque cuesta hacer el responsive si hay tantos campos */}
        {/* <input
          type="number"
          min={1}
          max={pageOptions?.length}
          placeholder="Anar a pàgina..."
          onChange={(e) => {
            const selectedPage =
              Number(e.target.value) - 1 > pageOptions.length
                ? pageOptions.length - 1
                : Number(e.target.value) - 1 < 1
                  ? 0
                  : Number(e.target.value) - 1

            gotoPage(selectedPage)
          }}
          className="block w-1/2 px-3 py-2 text-sm text-gray-700 bg-white border rounded-sm outline-none sm:w-36 placeholder-gray-400/70 dark:placeholder-gray-500 border-accent dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300"
        /> */}

        <div className="flex w-1/2 sm:hidden"></div>
      </div>

      <div className="flex items-center justify-start col-span-12 mt-4 lg:col-span-4 lg:justify-end gap-x-4 lg:mt-0">
        <button
          title="Anterior"
          type="button"
          className="flex items-center justify-center w-1/2 px-5 py-2 space-x-2 text-sm text-white capitalize transition-colors duration-200 border rounded-sm bg-accent border-accent sm:w-36 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
          onClick={() => previousPage()}
          disabled={!canPreviousPage || pageOptions.length < 2}
        >
          <LuMoveLeft size={20} />
          <span>Anterior</span>
        </button>

        <button
          title="Siguiente"
          type="button"
          className="flex items-center justify-center w-1/2 px-5 py-2 space-x-2 text-sm text-white capitalize transition-colors duration-200 border rounded-sm bg-accent border-accent sm:w-36 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
          onClick={() => nextPage()}
          disabled={!canNextPage || pageOptions.length < 2}
        >
          <span>Siguiente</span>
          <LuMoveRight size={20} />
        </button>
      </div>
    </div>
  )
}

// Define los tipos de las props que recibe el componente actual
TableFooter.propTypes = {
  previousPage: PropTypes.func,
  canPreviousPage: PropTypes.bool,
  pageIndex: PropTypes.number,
  pageOptions: PropTypes.array,
  nextPage: PropTypes.func,
  canNextPage: PropTypes.bool,
  gotoPage: PropTypes.func,
  rows: PropTypes.array,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func
}
